import React, {forwardRef} from 'react'

import icons from './icons.svg'

const Icon = ({size, className, name, myref}) => {
  const FancySvg = forwardRef((_, ref) => (
    <svg
      ref={ref}
      xmlns="http://www.w3.org/2000/svg"
      xmlnsXlink="http://www.w3.org/1999/xlink"
      className={`icon-svg icon-svg--size-${size} ${className}`}>
      <use xlinkHref={`${icons}#${name}`} />
    </svg>
  ))

  if (myref) {
    return <FancySvg ref={myref} />
  }

  return (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      xmlnsXlink="http://www.w3.org/1999/xlink"
      className={`icon-svg icon-svg--size-${size} ${className}`}>
      <use xlinkHref={`${icons}#${name}`} />
    </svg>
  )
}

export default Icon
